import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForgotPasswordComponent } from './components/admin/forgot-password/forgot-password.component';
import { SigninComponent } from './components/Sign-in/sign-in.component';

const routes: Routes = [
  // { path: '', redirectTo: '/admin/dashboard', pathMatch: 'full' },
  // { path: '', redirectTo: 'sign-in', pathMatch: 'full' },
  { path: 'admin', loadChildren: () => import('./components/admin/admin.module').then(m => m.AdminModule) },
  { path: '', component: SigninComponent },
  { path: 'reset-password', component: ForgotPasswordComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
